import UIReadOnlyMixin from "../../UIReadOnlyMixin";

// @vue/component
export default {
  name: "UiTemplateReadOnly",
  mixins: [
    UIReadOnlyMixin,
  ],
  computed: {
    getModel() {
      return this.model;
    },
  },
};
